import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminDashboard from '../components/Admin/AdminDashboard';
import LabDashboard from '../components/Lab/LabDashboard';
import LabEmployeeDashboard from '../components/Lab/LabEmployeeDashboard';
import ClinicDashboard from '../components/Clinic/ClinicDashboard';
import PhlebotomistDashboard from '../components/Phlebotomist/PhlebotomistDashboard';
import SupplierDashboard from '../components/Supplier/SupplierDashboard';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import '../App.css';

const Dashboard = () => {
  const location = useLocation();
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
  const [activeTab, setActiveTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('tab') || 'overview';
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  /** Keep dashboard tab in sync with ?tab= — source of truth for Admin/Lab/etc. sub-views */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab') || 'overview';
    setActiveTab(tab);
  }, [location.search]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setSidebarOpen(!mobile);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderDashboard = () => {
    switch (user?.role) {
      case 'admin':
        return <AdminDashboard activeTab={activeTab} />;
      case 'lab':
        return <LabDashboard activeTab={activeTab} />;
      case 'lab_employee':
        return <LabEmployeeDashboard activeTab={activeTab} />;
      case 'clinic':
        return <ClinicDashboard activeTab={activeTab} />;
      case 'phlebotomist':
        return <PhlebotomistDashboard activeTab={activeTab} />;
      case 'supplier':
        return <SupplierDashboard activeTab={activeTab} />;
      default:
        return <div>Unknown role</div>;
    }
  };

  return (
    <div className="App">
      <Navbar 
        user={user} 
        logout={logout}
        sidebarOpen={sidebarOpen}
        onToggleSidebar={() => setSidebarOpen(prev => !prev)}
        isMobile={isMobile}
      />
      <div
        className="dashboard-shell"
        style={{
          display: 'flex',
          minHeight: 'calc(100dvh - 80px)',
          boxSizing: 'border-box',
          position: 'relative',
          paddingTop: '0',
          minWidth: 0,
          maxWidth: '100%'
        }}
      >
        <Sidebar 
          user={user} 
          isOpen={sidebarOpen}
          onToggle={() => setSidebarOpen(prev => !prev)}
          onClose={() => setSidebarOpen(false)} 
        />
        <main 
          className="dashboard-content"
          style={{
            marginLeft: !isMobile ? (sidebarOpen ? '256px' : '64px') : '0',
            width: !isMobile ? (sidebarOpen ? 'calc(100% - 256px)' : 'calc(100% - 64px)') : '100%',
            flex: '1 1 auto',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            padding: isMobile
              ? undefined
              : 'var(--dashboard-pad-y) max(var(--dashboard-pad-x), env(safe-area-inset-right, 0px)) max(var(--dashboard-pad-bottom), env(safe-area-inset-bottom, 0px)) max(var(--dashboard-pad-x), env(safe-area-inset-left, 0px))',
            maxWidth: '100%',
            minWidth: 0,
            overflowX: 'hidden',
            overflowY: 'auto',
            scrollBehavior: 'smooth',
            position: 'relative',
            minHeight: '100%',
            background: 'var(--bg-primary)'
          }}
        >
          {renderDashboard()}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;

